import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LendingComponent } from './master/lending/lending.component';
import { HrSidebarComponent } from './master/hr-sidebar/hr-sidebar.component';
import { AdminSidebarComponent } from './master/admin-sidebar/admin-sidebar.component';
import { PoSidebarComponent } from './master/po-sidebar/po-sidebar.component';
import { TimesheetSidebarComponent } from './master/timesheet-sidebar/timesheet-sidebar.component';
import { InvoiceSidebarComponent } from './master/invoice-sidebar/invoice-sidebar.component';
import { SowSidebarComponent } from './master/sow-sidebar/sow-sidebar.component';
import { LoginComponent } from './user/login/login.component';
import { CandidateLoginComponent } from './user/candidate/candidate-login/candidate-login.component';
import { CandidateAuthGuard } from './guards/CandidateAuth.guard';
import { VendorSidebarComponent } from './master/vendor-sidebar/vendor-sidebar.component';
import { ClientSidebarComponent } from './master/client-sidebar/client-sidebar.component';
import { authGuard } from './guards/auth.guard';
import { beforeLoginGuard } from './guards/before-login.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'SignIn',
    pathMatch: 'full'
  },
  {
    path: 'SignIn',
    canActivate: [beforeLoginGuard],
    component: LoginComponent,
  },
  {
    path: 'CandidateSignIn',
    component: CandidateLoginComponent,
  },
  {
    path: 'CandidateProfile',
    loadComponent: () => import('./user/candidate/candidate-profile/candidate-profile.component')
      .then(m => m.CandidateProfileComponent),
    canActivate: [CandidateAuthGuard]
  },
  {
    path: 'CandidateReview',
    loadComponent: () => import('./area/module/hr/hrreview/CandidateReview/candidate-review/candidate-review.component')
      .then(m => m.CandidateReviewComponent),
    canActivate: [CandidateAuthGuard]
  },
  {
    path: 'chat',
    loadComponent: () =>
      import('./area/module/AI/chat-page/chat-page.component')
        .then(m => m.ChatPageComponent)
  },
  {
    path: 'landing',
    component: LendingComponent,
    canActivate: [authGuard]
  },
  {
    path: 'HR',
    component: HrSidebarComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./area/module/hr/hr.module').then(m => m.HrModule)
      }
    ]
  },
  {
    path: 'SysAdmin',
    component: AdminSidebarComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./area/module/admin/admin.module').then(m => m.AdminModule)
      }
    ]
  },
  {
    path: 'PO',
    component: PoSidebarComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./area/module/po/po.module').then(m => m.PoModule),
      }
    ]
  },
  {
    path: 'Sow',
    component: SowSidebarComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./area/module/sow/sow.module').then(m => m.SowModule),
      }
    ]
  },
  {
    path: 'Timesheet',
    component: TimesheetSidebarComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./area/module/timesheet/timesheet.module').then(m => m.TimesheetModule),
      }
    ]
  },
  {
    path: 'Inventory',
    component: InvoiceSidebarComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./area/module/invoice/inventory.module').then(m => m.InvoiceModule),
      }
    ]
  },
  {
    path: 'Vendor',
    component: VendorSidebarComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./area/module/vendor/vendor.module').then(m => m.VendorModule),
      }
    ]
  },
  {
    path: 'Client',
    component: ClientSidebarComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./area/module/client/client.module').then(m => m.ClientModule),
      }
    ]
  },
  {
    path: 'FormBuilder',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./area/module/form-builder/form-builder.module').then(m => m.FormBuilderModule),
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'SignIn'
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
